import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { applyTheme, THEMES } from "@/lib/themes";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const [theme, setThemeName] = useState(() => localStorage.getItem("acas_theme") || "default");
  const [mode, setMode] = useState(() => localStorage.getItem("acas_mode") || "light");

  useEffect(() => {
    applyTheme(theme, mode);
    localStorage.setItem("acas_theme", theme);
    localStorage.setItem("acas_mode", mode);
  }, [theme, mode]);

  // Sync from user profile on login
  useEffect(() => {
    if (user?.theme && THEMES[user.theme]) {
      setThemeName(user.theme);
    }
  }, [user]);

  const setTheme = useCallback(async (name) => {
    setThemeName(name);
    try {
      await api.post("/auth/theme", { theme: name });
    } catch (e) { /* swallow */ }
  }, []);

  const toggleMode = useCallback(() => setMode((m) => (m === "light" ? "dark" : "light")), []);

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, mode, setMode, toggleMode, themes: THEMES }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
